window.app_models.address = {
    "id":null,
    "address":null,
    "city":null,
    "zip":null,
    "state_id":null,
    "latitude":null,
    "longitude":null,
    "state":window.app_models.state
};


// WEBPACK FOOTER //
// ./resources/assets/js/models/address.js